var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoni(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 35,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 590,
    y: 367,
    width: 107,
    height: 35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1019175,
    height: 333375
  })), /*#__PURE__*/React.createElement("image", {
    width: 118,
    height: 38,
    xlinkHref: "data:image/png;base64,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",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1019175,
    height: 328209
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-590 -367)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000104987 0 0 0.000104987 590 367)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    transform: "matrix(1 0 0 1.01574 -0.5 0)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "scale(8637.08 8637.08)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoni);
export default __webpack_public_path__ + "static/media/MONI.d010772b1fd29dc8b2abb7e84fb00701.svg";
export { ForwardRef as ReactComponent };